import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_15: FaireProductEntity = {
  token: "legacy_prod_abbott-15",
  type: "product",
  name: "White LED Taper Candle 9.5 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/ccbfefc01a3ca95400360b4730de8690badb9ae54badb00c5256dbcb2b52775a.jpeg",
  priceDollars: 14,
  msrpDollars: 28,
  subcategory: "Taper Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
